// The plan catalogue.
//
// Prices live on the server — an admin can change them in SubscriptionConfig —
// so derivePlans reads them from /payments/price-info/ and only falls back to
// the values below when that has not loaded yet. Quoting a bundled price the
// checkout will not charge is the failure this is shaped to avoid.
//
// Names are catalogue keys, not text: this module is read at import time, and
// a name written here would stay in the language the app loaded in. Components
// render t(plan.nameKey).
//
// The legacy plan is deliberately absent: it is a grandfathered price nobody
// can move onto, and its subscribers cannot move off it either.
const CATALOGUE = [
	{ id: "WK", key: "weekly", nameKey: "payments:plans.weekly", duration: 7, totalPrice: 6.99, save: 0 },
	{ id: "MO", key: "monthly", nameKey: "payments:plans.monthly", duration: 30, totalPrice: 14.99, save: 50, preferred: true },
	{ id: "QU", key: "quarterly", nameKey: "payments:plans.quarterly", duration: 90, totalPrice: 29.99, save: 67 },
	{ id: "YR", key: "yearly", nameKey: "payments:plans.yearly", duration: 365, totalPrice: 99.99, save: 73 },
];

export const CURRENCY = "EUR";

// Kept as flat maps because the Pixel reporting and the subscribe hook only
// ever need to look one plan up by code.
export const PLAN_PRICES = Object.fromEntries(
	CATALOGUE.map((plan) => [plan.id, plan.totalPrice])
);

export const PLAN_NAME_KEYS = Object.fromEntries(
	CATALOGUE.map((plan) => [plan.id, plan.nameKey])
);

export function derivePlans(priceInfo) {
	return CATALOGUE.map((plan) => {
		const live = priceInfo?.plans?.[plan.key];

		const totalPrice = live?.price ?? plan.totalPrice;
		const duration = live?.days ?? plan.duration;

		return {
			...plan,
			totalPrice,
			duration,
			currency: live?.currency ?? CURRENCY,
			// Arithmetic, so it follows the live price rather than being
			// stated separately and contradicting it. `save` stays as written:
			// it is marketing copy, not a number derived from the charge.
			pricePerDay: Math.round((totalPrice / duration) * 100) / 100,
		};
	});
}
